import { render, staticRenderFns } from "./StyleDialogStyleRows.vue?vue&type=template&id=19d4e8f6&"
import script from "./StyleDialogStyleRows.vue?vue&type=script&lang=js&"
export * from "./StyleDialogStyleRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports